import { Box, Icon, Prose, Tag } from '@factorialco/deprecated-design-system'
import { AtsAiSummaryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  data: AtsAiSummaryFragment
}

export const AISummary = ({ data }: Props) => {
  const parsedDetails = JSON.parse(data.details)
  const reflection = parsedDetails.reflection

  return (
    <Box
      padding="s4"
      paddingTop="s12"
      gap="s12"
      borderRadius={{ all: 'abs012' }}
      background="purple200"
    >
      <Tag type="purple" icon="ai" iconColor="grey800" inline>
        <Box flexDirection="row" gap="s8" alignItems="center">
          <Icon.Small icon="ai" color="grey800" />
          {data?.topMatch
            ? i18n.t('ats.application_details.ai_summary.title_match')
            : i18n.t('ats.application_details.ai_summary.title')}
        </Box>
      </Tag>
      <Box padding="s12" borderRadius={{ all: 'abs010' }} background="lighter320">
        {reflection && (
          <Prose size="200" fullWidth>
            {reflection}
          </Prose>
        )}
      </Box>
    </Box>
  )
}
